/**
 * Firebase Configuration
 * Initializes Firebase app and exports services
 */

import { initializeApp } from 'firebase/app'
import { getStorage, connectStorageEmulator } from 'firebase/storage'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'demo-api-key',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'startuphive-dlr-dev.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'startuphive-dlr-dev',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'startuphive-dlr-dev.appspot.com',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '123456789',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || 'demo-app-id'
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Firebase Storage
export const storage = getStorage(app)

// Connect to Storage Emulator in development
if (import.meta.env.DEV) {
  console.log('Using Firebase Storage Emulator on localhost:9199')
  connectStorageEmulator(storage, 'localhost', 9199)
}

export default app
